export default "__VITE_ASSET__DdFBmn41__"